import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import mouviKit from './plugins/mouvi-kit';
import shareon from 'shareon';

shareon();

//  css
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
import '@/assets/styles/main.css';
import 'tippy.js/dist/tippy.css';
import 'vue3-pagination/dist/vue3-pagination.css';
import 'nouislider/distribute/nouislider.css';
import 'skeleton-screen-css';

createApp(App)
  .use(store)
  .use(mouviKit)
  .use(router)
  .mount('#app');
